'use client';

import './styles.scss';
import { useState } from 'react';
import DisplayDestinationUrlComponent from '../display-destination-url-component';
import MissingTrackingParamsComponent from '../missing-tracking-parameters-component';

interface HeaderProps {
  missingTrackingParams: string[];
  shouldShowMissingTrackingParams: boolean;
  destinationUrl: string;
  shouldDisplayRedirectUrl: boolean;
}

const Header: React.FC<HeaderProps> = ({
  shouldShowMissingTrackingParams,
  missingTrackingParams,
  shouldDisplayRedirectUrl,
  destinationUrl,
}) => {
  const [isDisplayUrlDismissed, setIsDisplayUrlDismissed] = useState(false);
  const [isErrorMessageDismissed, setErrorMessageDismissed] = useState(false);

  const handleDismiss = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (event.currentTarget.name === 'dismissDestinationUrlButton') {
      setIsDisplayUrlDismissed(true);
    } else if (
      event.currentTarget.name === 'dismissMissingTrackingParamsButton'
    ) {
      setErrorMessageDismissed(true);
    }
  };

  return (
    <>
      {shouldShowMissingTrackingParams &&
        missingTrackingParams.length > 0 &&
        !isErrorMessageDismissed && (
          <div className="missing-tracking-params">
            <MissingTrackingParamsComponent
              missingTrackingParams={missingTrackingParams}
            />
            <br />
            <button
              type="button"
              name="dismissMissingTrackingParamsButton"
              className="dismiss-button"
              onClick={handleDismiss}
            >
              Dismiss
            </button>
          </div>
        )}
      {shouldDisplayRedirectUrl && !isDisplayUrlDismissed && (
        <div className="display-destination-url">
          <DisplayDestinationUrlComponent destinationUrl={destinationUrl} />
          <br />
          <button
            type="button"
            name="dismissDestinationUrlButton"
            className="dismiss-button"
            onClick={handleDismiss}
          >
            Dismiss
          </button>
        </div>
      )}
    </>
  );
};

export default Header;
